// extracted by mini-css-extract-plugin
module.exports = {"inner":"CustomerCard_inner__Nyreo"};